/**
 * @generated SignedSource<<ad9fe8fed9352c5164608e2dc4094d85>>
 * @lightSyntaxTransform
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eaInput"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "eaInput"
      }
    ],
    "concreteType": "SubmitExtensionAddendumDocusignMutationPayload",
    "kind": "LinkedField",
    "name": "submitExtensionAddendumDocusign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AccessRequestDraft",
        "kind": "LinkedField",
        "name": "accessRequestDraft",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contemplatedUse",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExtensionAddendumSubmitOptions_Mutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ExtensionAddendumSubmitOptions_Mutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "116bc0107a8ce9d065e186334eb6bed5",
    "id": null,
    "metadata": {},
    "name": "ExtensionAddendumSubmitOptions_Mutation",
    "operationKind": "mutation",
    "text": "mutation ExtensionAddendumSubmitOptions_Mutation(\n  $eaInput: SubmitExtensionAddendumDocusignMutationInput!\n) {\n  submitExtensionAddendumDocusign(input: $eaInput) {\n    accessRequestDraft {\n      id\n      contemplatedUse\n    }\n    error {\n      type\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1e22ce5938e8209bd4a07674cf2b6a48";

export default node;
